import {Moment} from 'moment';
import {CustomDateMask} from '../custom-mask/enums/custom-mask-regex';
import {MaskValidator} from '../custom-mask/validators/mask-validator/mask-validator';

export interface Mask<T extends keyof MaskValidatorMethodMap> {
  masks: Masks;
  validateMask?: boolean;
  validator?: MaskValidatorConfig<T>; //[];
  maskText?: string;
}

export type MaskValidatorConfig<T extends keyof MaskValidatorMethodMap> = {
  args: MaskValidatorMethodMap[T];
  type: T;
};

export type MaskValidatorMethodMap = {
  [MaskValidatorFunctions.DATE]: currencyDate;
  [MaskValidatorFunctions.STANDARD]: standardArgs;
  [MaskValidatorFunctions.CURRENCY]: currencyArgs;
  [MaskValidatorFunctions.MAIL]: currencyMail;
};

export type currencyArgs = {
  min?: number;
  blur: boolean;
  max: number;
  isDeleting: never;
  mailRegex: never;
};

export type currencyDate = {
  min: Moment;
  max: Moment;
  isDeleting?: string;
  blur?: never;
  mailRegex?: never;
};

export type currencyMail = {
  mailRegex: RegExp;
  min?: never;
  max?: never;
  blur?: never;
  isDeleting?: never;
};

export type standardArgs = {
  mailRegex?: never;
  min?: never;
  max?: never;
  blur?: never;
  isDeleting?: never;
};

export interface MaskDirective<T extends keyof MaskValidatorMethodMap = keyof MaskValidatorMethodMap> extends Mask<T> {
  masks: MaskElementDirective[];
}

export type Masks = MaskElement[] | MaskElement | string | RegExp | RegExp[] | CustomDateMask;

export type MaskElement =
  | {
      mask: string | CustomDateMask | RegExp;
      maskText?: string;
    }
  | {
      mask: (RegExp | string)[];
      maskText: string;
    };

export type MaskElementDirective = {
  mask: (RegExp | string)[];
  maskText: string;
};

export enum MaskValidatorFunctions {
  CURRENCY = 'currency',
  STANDARD = 'standard',
  DATE = 'date',
  MAIL = 'mail',
}
